import React from 'react';
import { useTutorial } from './TutorialContext';
import useTranslations from '../../Hooks/useTranslations';
import translations from './translations.json';
import { FaGraduationCap, FaArrowRight } from 'react-icons/fa';
import './css/tutorialWelcome.css';

export default function TutorialWelcomeModal() {
  const { showWelcome, startTutorial, skipTutorial } = useTutorial();
  const t = useTranslations(translations);

  if (!showWelcome) return null;

  return (
    <div className="tutorial-component-welcome-backdrop" onClick={skipTutorial}>
      <div className="tutorial-component-welcome-card" onClick={(e) => e.stopPropagation()}>
        <div className="tutorial-component-welcome-icon-wrapper">
          <FaGraduationCap className="tutorial-component-welcome-icon" />
        </div>

        <h2 className="tutorial-component-welcome-title">
          {t.tutorial?.welcome_title || 'Welcome to HappyChef!'}
        </h2>
        <p className="tutorial-component-welcome-desc">
          {t.tutorial?.welcome_description || 'Let us show you around the dashboard. We\'ll guide you through the key features step by step.'}
        </p>

        <div className="tutorial-component-welcome-actions">
          <button
            onClick={startTutorial}
            className="tutorial-component-welcome-btn-primary"
          >
            {t.tutorial?.welcome_start || 'Start Tutorial'}
            <FaArrowRight style={{ marginLeft: 8 }} />
          </button>
          <button
            onClick={skipTutorial}
            className="tutorial-component-welcome-btn-ghost"
          >
            {t.tutorial?.welcome_skip || 'Skip Tutorial'}
          </button>
        </div>
      </div>
    </div>
  );
}
